window.ITEMS_CATALOG = {

  "zimaxenvase": {
    id: "zimaxenvase",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/zim.png?v=1767641374",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=20984008802381"
  },
    "zimaxsobres": {
    id: "zimaxsobres",
    top: "https://cdn.shopify.com/s/files/1/2632/8386/files/12_zimax_sobres.png?v=1767664096",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=28694096543821"
  },
  "glutathione": {
    id: "glutathione",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/03_GLUTATHIONE_5742ee00-155b-41f8-9681-dafdbffa76f2.png?v=1760981430",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=43930890010859"
  },
  "anxietas": {
    id: "anxietas",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/05_anxietas_433866b7-616b-40e7-a41c-3ba952c89e9e.png?v=1760983459",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=44324604248299"
  },
  "collagen": {
    id: "collagen",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/04_COLLAGEN_7455f429-c402-4816-b455-880097a17226.png?v=1760981824",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=43479893344491"
  },
  "creatine": {
    id: "creatine",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/creatine_es.png?v=1768840523",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=46447062876395"
  },
  "vitaminaD3": {
    id: "vitaminaD3",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_VITAMIN_D3_5f436d93-26be-4acb-ae19-4ee0c7a3e7c7.png?v=1757538652",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=45844937212139"
  },
    "vitaminaD3K2": {
    id: "vitaminaD3K2",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/vitamin_d3_k2_es.png?v=1772021930",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=46197771010283"
  },
  "metabolic": {
    id: "metabolic",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/09_metabolic_ea217618-47d0-4c74-8f83-dac7790d7d3a.png?v=1760982592",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=45844962410731"
  },
  "magnesium": {
    id: "magnesium",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/06_magnesium_8d3886b1-8ff5-495e-a063-fc45e2c890e0.png?v=1760981862",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=1218879619097"
  },
  "cincuenta": {
    id: "cincuenta",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/02_BALANCE_efaf854d-d89e-41b9-9352-4c9727c0417b.png?v=1760982473",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=44382698504427"
  },
    "365": {
    id: "365",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/10_365greens_534a66e2-6bd1-4948-b4f2-2236e6421c38.png?v=1761100309",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=44073237872875"
  },

  "glutathione-en": {
    id: "glutathione-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/03_GLUTATHIONE_en.png?v=1761096578",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add-en.svg?v=1792588390",
    url: "/cart/add?id=44132793155824"
  },

  "anxietas-en": {
    id: "anxietas-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/05_anxietas_en.png?v=1761096578",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add-en.svg?v=1792588390",
    url: "/cart/add?id=44402535137520"
  },

  "collagen-en": {
    id: "collagen-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/04_COLLAGEN_en_92ee7c63-79ec-4be8-8c7c-76d8c2d63789.png?v=1761096578",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add-en.svg?v=1792588390",
    url: "/cart/add?id=43778462679280"
  },

    "zimaxenvase-en": {
    id: "zimaxenvase-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/01_zimax_envase_en_3.png?v=1767724031",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add-en.svg?v=1792588390",
    url: "/cart/add?id=29435722072109"
  },


  "magnesium-en": {
    id: "magnesium-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/06_magnesium-en.png?v=1761096578",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add-en.svg?v=1792588390",
    url: "/cart/add?id=13601316667437"
  },

  "cincuenta-en": {
    id: "cincuenta-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/02_BALANCE_en.png?v=1761096578",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add-en.svg?v=1792588390",
    url: "/cart/add?id=44553646964976"
  },

  "metabolic-en": {
    id: "metabolic-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/09_metabolic_en.png?v=1761097888",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add-en.svg?v=1792588390",
    url: "/cart/add?id=44416570196208"
  },

  "indispensable": {
    id: "indispensable",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/kit-indis.png?v=1767723141",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=32241320558669"
  },

  "antiinflamatorio": {
    id: "antiinflamatorio",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/11_kit_antiinflamatorio_1_5d9dfd99-6524-4f09-8105-a1debc0052ab.png?v=1767723402",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=46864863068395"
  },

    "vitaminac": {
    id: "vitaminac",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/vitamin_c_es.png?v=1768840522",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=45692444999915"
  },

  "paleomega": {
    id: "paleomega",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/paleomega_es_2.png?v=1768919381",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_1_s.svg?v=1792426657",
    url: "/cart/add?id=24363163526"
  },

  "creatineEN": {
    id: "creatineEN",
    top: "https://cdn.shopify.com/s/files/1/2632/8386/files/creatine_en.png?v=1768859765",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/btt_f7b77e3b-96bd-4a30-9c05-68bfd501836f.png?v=1772113434",
    url: "/cart/add?id=47587784589552"
  },

  "paleomegaEN": {
    id: "paleomegaEN",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/paleomega_en_1.png?v=1768919380",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add.svg?v=1773698459",
    url: "/cart/add?id=43780015522032"
  },
  "vitaminaD3K2-En": {
    id: "vitaminaD3K2-En",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/vitamin_d3_k2_en_1.png?v=1772120914",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add.svg?v=1773698459",
    url: "/cart/add?id=47239906361584"
  },

  "vitaminacEN": {
    id: "vitaminacEN",
    top: "https://cdn.shopify.com/s/files/1/2632/8386/files/vitamin_c_en.png?v=1768859764",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/add.svg?v=1773698459",
    url: "/cart/add?id=46441854959856"
  },

    "3x2flexijoint": {
    id: "3x2flexijoint",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_flexijoint.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413238358251"
  },
  

  "3x2metabolic": {
    id: "3x2metabolic",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_METABOLIC.webp?v=1789522421",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413215256811"
  },

  "3x2zimaxsobres": {
    id: "3x2zimaxsobres",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_ZMAX_SOBRES.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49414726844651"
  },

  "3x2oregarlix": {
    id: "3x2oregarlix",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_OREGARLIX.webp?v=1789522421",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413167775979"
  },

    "3x2newton": {
    id: "3x2newton",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_NEWTON.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413158863083"
  },

  "3x2junior": {
    id: "3x2junior",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_ZMAX_JUNIOR.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413138415851"
  },

  "3x2paleomega": {
    id: "3x2paleomega",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_PALEOMEGA.webp?v=1789522421",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413096276203"
  },

  "3x2vitaminad3k2": {
    id: "3x2vitaminad3k2",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_VITAMIN_D3_K2.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49414830686443"
  },

  "3x2vitaminac": {
    id: "3x2vitaminac",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_VITAMIN_C.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413026971883"
  },

  "3x2vitaminad3": {
    id: "3x2vitaminad3",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_VITAMIN_D3.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413016682731"
  },

  "3x2cimmu": {
    id: "3x2cimmu",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_CIMMUNITY.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49413007638763"
  },

  "3x2selenium": {
    id: "3x2selenium",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_SELENIUM.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49412995055851"
  },

  "3x2cusivip": {
    id: "3x2cusivip",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_CUSIFIT_VIP.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49412966940907"
  },

  "3x2indispensable": {
    id: "3x2indispensable",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_INDISPENSIBLE.webp?v=1789522421",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49412944396523"
  },

  "3x2detox": {
    id: "3x2detox",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_DETOX_ANTIINFLAMATORIO.webp?v=1789522421",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49429988049131"
  },

  "3x2balance": {
    id: "3x2balance",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_BALANCE.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49412650008811"
  },

    "3x2365": {
    id: "3x2365",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_365greens.webp?v=1789522420",
    bottom: "https://cdn.shopify.com/s/files/1/0935/8216/files/btt_e51c7fcb-f431-4ee8-aca1-35cff24967c9.svg?v=1789526287",
    url: "/cart/add?id=49412649550059"
  },

  "3x2flexijoint-en": {
    id: "3x2flexijoint-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_flexijoint_2c9add0c-3017-468b-b48c-295b791f1ee6.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50506938515696"
  },
  

  "3x2metabolic-en": {
    id: "3x2metabolic-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_METABOLIC_511e14fb-9a81-4b61-87da-464ef307674c.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50507001561328"
  },

  "3x2zimaxsobres-en": {
    id: "3x2zimaxsobres-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_ZMAX_SOBRES_f641e272-a0ad-4a92-8a48-2c9f6a9a3857.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50506982588656"
  },

  "3x2oregarlix-en": {
    id: "3x2oregarlix-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_OREGARLIX_29bd9d3e-d6f1-4a97-a466-13c20a53c9c4.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50506997793008"
  },

    "3x2newton-en": {
    id: "3x2newton-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_NEWTON_65048051-e50a-4f10-9dde-8d40ef436d23.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50506999628016"
  },

  "3x2junior-en": {
    id: "3x2junior-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_ZMAX_JUNIOR_876010b3-da67-4a37-98fd-7e60df9d0585.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50506986914032"
  },

  "3x2paleomega-en": {
    id: "3x2paleomega-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_PALEOMEGA_61732ffb-029b-424d-a6a3-97a68138ff24.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50507182768368"
  },

  "3x2vitaminad3k2-en": {
    id: "3x2vitaminad3k2-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_VITAMIN_D3_K2_16fbefad-92bc-4bfc-ae9f-90c7bf2e79a3.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=47263074353392"
  },

  "3x2vitaminac-en": {
    id: "3x2vitaminac-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_VITAMIN_C_ed91ebd5-81d6-45f4-be31-bfe22bf88b7e.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50507189911792"
  },

  "3x2vitaminad3-en": {
    id: "3x2vitaminad3-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_VITAMIN_D3_b25cf0e1-7391-4ff8-8012-567cfbd91d0d.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50507194433776"
  },

  "3x2cimmu-en": {
    id: "3x2cimmu-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_CIMMUNITY_fb3ccb82-8256-47f3-9288-722c95100154.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50506945036528"
  },

  "3x2selenium-en": {
    id: "3x2selenium-en",
    top: "https://cdn.shopify.com/s/files/1/0935/8216/files/00_SELENIUM_1539fe90-d9a3-4fea-9d85-6565c9545e1e.webp?v=1790006239",
    bottom: "https://cdn.shopify.com/s/files/1/2632/8386/files/add-en.svg?v=1789923041",
    url: "/cart/add?id=50507199545584"
  },







  "mag1": { id: "mag1", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_f1944ce2-b45f-4343-bb0a-e09f103207e7.jpg?v=1764962503", bottom: "", url: "#" },
  "mag2": { id: "mag2", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_5f8d4cee-bb6b-44cf-88e2-d0c9a979152c.jpg?v=1764962502", bottom: "", url: "#" },
  "mag3": { id: "mag3", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_f40a5c1d-da42-4aa2-85fe-dda32f07ce85.jpg?v=1764962502", bottom: "", url: "#" },
  "mag4": { id: "mag4", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review04_c7c7f21a-1631-4beb-b4ed-7e0c23350f0a.jpg?v=1764962502", bottom: "", url: "#" },
  "r5": { id: "r5", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review05_06a3597d-5bbb-4ce0-8758-5778cf030b71.jpg?v=1760984565", bottom: "", url: "#" },
  "r1en": { id: "r1en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_5_39c24514-7eaa-4be7-a1b0-a07943481b6e.jpg?v=1761098013", bottom: "", url: "#" },
  "r2en": { id: "r2en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_5_81f84121-cbc2-412c-8900-aa977998adc8.jpg?v=1761098013", bottom: "", url: "#" },
  "r3en": { id: "r3en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_6_3e3ba055-aa03-4ebb-89b3-8ac84edddd39.jpg?v=1761098013", bottom: "", url: "#" },
  "r4en": { id: "r4en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review04_3_bc61dac1-0a46-471e-b151-ec360a3d7a2b.jpg?v=1761098013", bottom: "", url: "#" },
  "r5en": { id: "r5en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review05_1_0e38fde7-a7f0-4b01-a274-faace5d01ec8.jpg?v=1761098013", bottom: "", url: "#" },
  "rDesindla1ES": { id: "rDesindla1ES", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_475c484f-d584-4e76-9ffc-78334cba6349.jpg?v=1767633610", bottom: "", url: "#" },
  "rDesindla2ES": { id: "rDesindla2ES", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_f7b26e3f-6291-4fd3-a931-708b0bfd6bba.jpg?v=1767633610", bottom: "", url: "#" },
  "rDesindla3ES": { id: "rDesindla3ES", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_fd08d6b3-d925-4e4d-9383-69aa800a119f.jpg?v=1767633610", bottom: "", url: "#" },
  "rDesindla1EN": { id: "rDesindla1EN", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_1_11e86bbe-9a5e-42b1-8994-e5ff807b79d5.jpg?v=1767662320", bottom: "", url: "#" },
  "rDesindla2EN": { id: "rDesindla2EN", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_1_fa782ef6-cb51-444e-97b6-3603f7d2455e.jpg?v=1767662321", bottom: "", url: "#" },
  "rDesindla3EN": { id: "rDesindla3EN", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_1_dda08f33-8cbe-4a5a-8054-787d47fea0aa.jpg?v=1767662321", bottom: "", url: "#" },
  "revcola1": { id: "revcola1", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_0bdb2160-5f0e-4b31-94ec-a670acc9e753.jpg?v=1768654354", bottom: "", url: "#" },
  "revcola2": { id: "revcola2", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_23898abd-036f-4577-8c5d-f130677e8a2f.jpg?v=1768654354", bottom: "", url: "#" },
  "revcola3": { id: "revcola3", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_31abf254-8c77-47cf-9ca8-b9869618aed5.jpg?v=1768654354", bottom: "",  url: "#" },
  "revcola1en": { id: "revcola1en", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/review01_1_d1598183-b229-4ee4-90a9-d9a36600eb3e.jpg?v=1768771007", bottom: "", url: "#" },
  "revcola2en": { id: "revcola2en", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/review02_1_0cb04b8f-dafa-4aef-b462-59a1428cd23d.jpg?v=1768771007", bottom: "", url: "#" },
  "revcola3en": { id: "revcola3en", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/review03_1_36021aec-a0e5-49db-a1f6-ec3052be6059.jpg?v=1768771007", bottom: "",  url: "#" },
  "revAnxietas": { id: "revAnxietas", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_118db7ed-a864-44f7-921c-9b4035a4eabd.png?v=1771981904", bottom: "",  url: "#" },
  "revAnxietas2": { id: "revAnxietas2", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02.png?v=1771981903", bottom: "",  url: "#" },
  "revAnxietas3": { id: "revAnxietas3", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_6faf8ae5-626e-4fe2-9e0f-f94868ad12bf.png?v=1771981904", bottom: "",  url: "#" },
  "revAnxietas1En": { id: "rrevAnxietas1En", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_1.png?v=1772118254", bottom: "",  url: "#" },
  "revAnxietas2En": { id: "revAnxietas2En", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_1.png?v=1772118254", bottom: "",  url: "#" },
  "revAnxietas3En": { id: "revAnxietas3En", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_1.png?v=1772118254", bottom: "",  url: "#" },
  "revd3k2-1es": { id: "revd3k2-1es", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01.webp?v=1772717130", bottom: "",  url: "#" },
  "revd3k2-2es": { id: "rrevd3k2-2es", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02.webp?v=1772717130", bottom: "",  url: "#" },
  "revd3k2-3es": { id: "revd3k2-3es", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03.webp?v=1772717129", bottom: "",  url: "#" },
    "revd3k2-1en": { id: "revd3k2-1en", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/review01_1.png?v=1772730028", bottom: "",  url: "#" },
  "revd3k2-2en": { id: "rrevd3k2-2en", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/review02_1.png?v=1772730027", bottom: "",  url: "#" },
  "revd3k2-3en": { id: "revd3k2-3en", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/review03_1.png?v=1772730028", bottom: "",  url: "#" },
  "rzim-tmbl1": { id: "rzim-tmbl1", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_f977a5cc-ba78-492c-b60a-c66f48b420a8.jpg?v=1773419194", bottom: "",  url: "#" },
  "rzim-tmbl2": { id: "rzim-tmbl2", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_5458ed13-ef13-4be6-b834-fd17b35bd4dd.jpg?v=1773419194", bottom: "",  url: "#" },
  "rzim-tmbl3": { id: "rzim-tmbl3", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_f67d0cfb-7a5c-4241-8553-0af884c421b7.jpg?v=1773419219", bottom: "",  url: "#" },
  "rzim-tmbl4": { id: "rzim-tmbl4", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review04_0a319f01-4cfb-49e7-9543-796621a92a53.jpg?v=1773419194", bottom: "",  url: "#" },
  "rzim-tmbl5": { id: "rzim-tmbl5", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review05_68b1fadc-0fe3-4ef8-b2c3-a0f8d7f5eaaa.jpg?v=1773419194", bottom: "",  url: "#" },
  "rzim-tmbl1en": { id: "rzim-tmbl1en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review01_4d23fe11-ca71-4941-a162-7228ef76df88.jpg?v=1773698837", bottom: "",  url: "#" },
  "rzim-tmbl2en": { id: "rzim-tmbl2en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review02_385458df-8d39-48a4-ad38-74df2bf1343d.jpg?v=1773698837", bottom: "",  url: "#" },
  "rzim-tmbl3en": { id: "rzim-tmbl3en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review03_9f01b3f7-5b09-4a64-849a-aed5245bbe3d.jpg?v=1773698837", bottom: "",  url: "#" },
  "rzim-tmbl4en": { id: "rzim-tmbl4en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review04_1324e4e9-e330-4af1-a7de-1250b3ab5532.jpg?v=1773698838", bottom: "",  url: "#" },
  "rzim-tmbl5en": { id: "rzim-tmbl5en", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/review05_0ce7ffaa-fe3a-4009-a5b1-0e26f594dc00.jpg?v=1773698837", bottom: "",  url: "#" },
  "r-cusi-es1": { id: "r-cusi-es1", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_38_1fd41be4-249a-4387-a3de-063f77e146fc.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es2": { id: "r-cusi-es2", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_26.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es3": { id: "r-cusi-es3", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_27_d77e5608-d632-4bd4-9359-feedf9233710.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es4": { id: "r-cusi-es4", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_36_3ced7626-aeba-4e35-a586-c40f25b15b7a.webp?v=1780584994", bottom: "",  url: "#" },
  "r-cusi-es5": { id: "r-cusi-es5", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_25_bbc3bf15-b703-41c7-894b-822ac3b22b74.webp?v=1780584994", bottom: "",  url: "#" },
  "r-cusi-es6": { id: "r-cusi-es6", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_22_6e397f4d-7232-49af-9cbc-13760307febe.webp?v=1780584994", bottom: "",  url: "#" },
  "r-cusi-es7": { id: "r-cusi-es7", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_30_8feb63af-8cf3-4451-bf08-40e45a2bd204.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es8": { id: "r-cusi-es8", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_32_be93df05-ac12-4c8c-b399-8f5541f6612d.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es9": { id: "r-cusi-es9", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_35_7b24eef2-cb63-484d-9d50-72bb42cf2c07.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es10": { id: "r-cusi-es10", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_33_c2f2c1a1-9074-4261-849a-4e203f39f613.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es11": { id: "r-cusi-es11", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_14_f39f2159-b78c-489b-97d7-3fc9c4320e5a.webp?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es12": { id: "r-cusi-es12", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_39_5bee27fd-174d-43a7-a531-27f67a44df20.png?v=1780584993", bottom: "",  url: "#" },
  "r-cusi-es13": { id: "r-cusi-es13", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_11_d2bf5114-392b-40a7-9111-cec833bd1dab.webp?v=1780584995", bottom: "",  url: "#" },
  "r-3x2-es1": { id: "r-3x2-es1", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/1.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es2": { id: "r-3x2-es2", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/2.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es3": { id: "r-3x2-es3", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/3_74def0f3-d25f-4829-8455-a45055d5624b.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es4": { id: "r-3x2-es4", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/4_be2ce03d-ca76-4dfc-b3d9-5a111a6fa3fc.png?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es5": { id: "r-3x2-es5", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/5_8e1b58a0-5692-45ab-b908-4632b36d0f01.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es6": { id: "r-3x2-es6", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_27_78cc8acf-2d93-4570-b9da-e5f0472799de.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es7": { id: "r-3x2-es7", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_14_baba264d-5fbb-4391-b382-c5f24c044463.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es8": { id: "r-3x2-es8", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_33_af2fa7d4-3cd4-4c83-8230-ae419de4ab9c.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es9": { id: "r-3x2-es9", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_22_322a3aca-9bd4-405c-ba4c-8d752bf65dd1.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es10": { id: "r-3x2-es10", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_26_356a6906-bfba-4528-a143-6fa0d39f81c7.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es11": { id: "r-3x2-es11", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_36_83456f7a-e36a-4696-91a1-85c5a9ab22b6.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es12": { id: "r-3x2-es12", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_38_2ad29644-eefb-4fe5-b54a-8a83da1dfbe7.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es13": { id: "r-3x2-es13", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_30_0320963d-839b-4162-82b3-b640b48b408b.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es14": { id: "r-3x2-es14", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_25_407f2f33-656a-440b-b77e-47e780994ea8.webp?v=1789481688", bottom: "",  url: "#" },
  "r-3x2-es15": { id: "r-3x2-es15", top: "https://cdn.shopify.com/s/files/1/0935/8216/files/Frame_1_98667945-99fd-4dc8-8a03-beb44255bd23.webp?v=1789481688", bottom: "",  url: "#" },
  
  "r-3x2-en1": { id: "r-3x2-en1", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/1.webp?v=1789923525", bottom: "",  url: "#" },
  "r-3x2-en2": { id: "r-3x2-en2", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/2.webp?v=1789923525", bottom: "",  url: "#" },
  "r-3x2-en3": { id: "r-3x2-en3", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/3.webp?v=1789923525", bottom: "",  url: "#" },
  "r-3x2-en4": { id: "r-3x2-en4", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/4.webp?v=1789923525", bottom: "",  url: "#" },
  "r-3x2-en5": { id: "r-3x2-en5", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_21_d4b6ff37-09e1-43d2-a983-05da686aad92.webp?v=1789923591", bottom: "",  url: "#" },
  "r-3x2-en6": { id: "r-3x2-en6", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_19_b363d0fa-960d-4b6d-9e1c-8a6e8b805827.webp?v=1789923591", bottom: "",  url: "#" },
  "r-3x2-en7": { id: "r-3x2-en7", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_17_2c1946a7-547f-449a-a6c7-a07967d494f5.webp?v=1789923591", bottom: "",  url: "#" },
  "r-3x2-en8": { id: "r-3x2-en8", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_23_4c66ba4c-4798-4181-866a-c8d8f749b09c.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en9": { id: "r-3x2-en9", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_16_a7ad0b5a-509b-408c-ab33-e94ccb7332fd.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en10": { id: "r-3x2-en10", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_4_7e09b965-70a3-41f3-ad10-712296ae63db.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en11": { id: "r-3x2-en11", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_34_ff92cc55-792f-40ac-b609-db2b0300fa80.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en12": { id: "r-3x2-en12", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_40_de935af6-6891-41c3-9fe1-1b47ca916c3f.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en13": { id: "r-3x2-en13", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_20_4cbbd45d-4e3a-4dae-8af5-9e7c4de9e265.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en14": { id: "r-3x2-en14", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_28_a2d7f33c-30bd-4d82-b552-ba0132e6b709.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en15": { id: "r-3x2-en15", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_3_3f860845-f973-461a-a7b7-1e7c8182bfef.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en16": { id: "r-3x2-en16", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_6_e8dd1c60-ad09-46b6-9406-a74fcb34de79.webp?v=1789923590", bottom: "",  url: "#" },
  "r-3x2-en17": { id: "r-3x2-en17", top: "https://cdn.shopify.com/s/files/1/2632/8386/files/Frame_42_0e053e6e-e62e-440d-bf6f-10af8668bd6a.webp?v=1789923590", bottom: "",  url: "#" },
  




};

// ===================== CARRUSEL =====================
(function(){
  "use strict";

  const TRANSITION_CSS = 'transform 350ms ease';

  // ====== Arranque global ======
  function initAllCarousels(){
    if (!window.ITEMS_CATALOG) {
      console.error('[Carousel X] No se encontró window.ITEMS_CATALOG. Carga primero tu JS remoto del catálogo.');
      return;
    }
    document.querySelectorAll('.x-carousel').forEach(initCarouselInstance);
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAllCarousels);
  } else {
    initAllCarousels();
  }

  // ====== Lógica por instancia ======
  function initCarouselInstance(root){
    // Config por data-attr
    const desktopCount = parseInt(root.getAttribute('data-desktop') || '3', 10);
    const mobileCount  = parseInt(root.getAttribute('data-mobile')  || '1', 10);

    // IDs a renderizar
    const ids = (root.getAttribute('data-items') || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);

    const baseItemsRaw = ids.map(id => {
      const it = window.ITEMS_CATALOG[id];
      if(!it){
        console.warn(`[Carousel X] ID "${id}" no existe en ITEMS_CATALOG.`);
        return null;
      }
      return { id, top: it.top, bottom: it.bottom, url: it.url, altTop: it.altTop || '', altBottom: it.altBottom || 'Banner' };
    }).filter(Boolean);

    const viewport = root.querySelector('.x-viewport');
    const track    = root.querySelector('.x-track');
    const btnPrev  = root.querySelector('.x-prev');
    const btnNext  = root.querySelector('.x-next');

    if (!viewport || !track || !btnPrev || !btnNext){
      console.error('[Carousel X] Faltan elementos internos (.x-viewport, .x-track, .x-prev, .x-next).');
      return;
    }

    // Safeties en runtime (sin depender del tema)
    viewport.style.touchAction = viewport.style.touchAction || 'pan-y';
    track.style.willChange = track.style.willChange || 'transform';
    track.style.transition = TRANSITION_CSS;
    root.style.position = root.style.position || 'relative';
    btnPrev.style.zIndex = btnPrev.style.zIndex || '3';
    btnNext.style.zIndex = btnNext.style.zIndex || '3';
    btnPrev.style.pointerEvents = btnPrev.style.pointerEvents || 'auto';
    btnNext.style.pointerEvents = btnNext.style.pointerEvents || 'auto';

    // Estado
    let itemsPerView = getItemsPerView();
    let currentIndex = 0;
    let slidesCount  = 0;
    let isAnimating  = false;
    let slideW       = 0;
    let gapPx        = 0;
    let baseItems    = baseItemsRaw.slice();

    // Estado para gestos
    let isPointerDown = false;
    let dragActive    = false;   // solo true si superamos el umbral de activación
    let didSwipe      = false;   // true si al soltar se decidió mover
    let preventClick  = false;   // bloquea solo el click inmediatamente posterior a un swipe

    let startX = 0, startY = 0;
    let deltaX = 0, deltaY = 0;
    let startT = 0;
    let baseOffsetPx = 0;

    // ====== Utilidades ======
    function getItemsPerView(){
      return (window.innerWidth < 768) ? mobileCount : desktopCount;
    }

    function ensureEnoughItems(min){
      if (baseItems.length === 0) return;
      while (baseItems.length < min){
        baseItems = baseItems.concat(baseItemsRaw);
      }
    }

    function createSlideDOM(item){
      const slide = document.createElement('div');
      slide.className = 'x-slide';

      const top = document.createElement('div');
      top.className = 'x-top';
      const topImg = document.createElement('img');
      topImg.src = item.top;
      topImg.alt = item.altTop || '';
      topImg.draggable = false;
      top.appendChild(topImg);

      const bottom = document.createElement('div');
      bottom.className = 'x-bottom';
      const link = document.createElement('a');
      // añade quantity=1 respetando si ya hay querystring
      link.href = `${item.url}${item.url?.includes('?') ? '&' : '?'}quantity=1`;
      const bottomImg = document.createElement('img');
      bottomImg.src = item.bottom || '';
      bottomImg.alt = item.altBottom || 'Banner';
      bottomImg.draggable = false;
      bottom.appendChild(bottomImg);

      link.appendChild(top);
      link.appendChild(bottom);

      slide.appendChild(link);
      return slide;
    }

    function disableTransition(){ track.style.transition = 'none'; }
    function enableTransition(){  track.style.transition = TRANSITION_CSS; }

    function getTransitionMs() {
      const cs = getComputedStyle(track);
      const dur = (cs.transitionDuration || '0s').split(',')[0].trim();
      return dur.endsWith('ms') ? parseFloat(dur)
           : dur.endsWith('s')  ? parseFloat(dur) * 1000
           : 0;
    }

    function measure(){
      const first = track.querySelector('.x-slide');
      if(!first) return;
      const cs = getComputedStyle(track);
      gapPx = parseFloat(cs.columnGap || cs.gap || '0') || 0;
      slideW = first.getBoundingClientRect().width;
    }

    function offsetForIndex(idx){
      return Math.round(idx * (slideW + gapPx));
    }

    function applyTransform(){
      const offset = offsetForIndex(currentIndex);
      track.style.transform = `translate3d(-${offset}px,0,0)`;
    }

    function applyTransformPx(offsetPx){
      track.style.transform = `translate3d(-${Math.round(offsetPx)}px,0,0)`;
    }

    function realignWithoutTransition(){
      measure();
      disableTransition();
      applyTransform();
      track.getBoundingClientRect(); // reflow
      enableTransition();
    }

    // ====== Build / Rebuild ======
    function build(){
      itemsPerView = getItemsPerView();
      root.style.setProperty('--items-per-view', itemsPerView);

      baseItems = baseItemsRaw.slice();
      ensureEnoughItems(itemsPerView + 1);

      track.innerHTML = '';

      if (baseItems.length === 0){
        console.warn('[Carousel X] Sin ítems para renderizar.');
        return;
      }

      // Clones para loop infinito
      const before = baseItems.slice(-itemsPerView);
      const after  = baseItems.slice(0, itemsPerView);
      const slides = [...before, ...baseItems, ...after];

      slides.forEach(item => track.appendChild(createSlideDOM(item)));

      slidesCount  = slides.length;
      currentIndex = itemsPerView; // primer real

      track.style.transition = TRANSITION_CSS;

      realignWithoutTransition();
      updateButtonsState(false);
    }

    // ====== Navegación por botones/teclas ======
    function step(delta){
      if(isAnimating) return;
      isAnimating = true;
      updateButtonsState(true);

      currentIndex += delta;
      enableTransition();
      applyTransform();

      // Fallback por si no llega transitionend
      const dur = getTransitionMs() || 350;
      setTimeout(() => {
        if (isAnimating) onTransitionEnd();
      }, dur + 60);
    }

    function onTransitionEnd(){
      const firstReal = itemsPerView;
      const lastReal  = itemsPerView + baseItems.length - 1;

      if (currentIndex > lastReal){
        disableTransition();
        currentIndex = firstReal;
        applyTransform();
        track.getBoundingClientRect();
        enableTransition();
      } else if (currentIndex < firstReal){
        disableTransition();
        currentIndex = lastReal;
        applyTransform();
        track.getBoundingClientRect();
        enableTransition();
      }

      isAnimating = false;
      updateButtonsState(false);
    }

    function updateButtonsState(disabled){
      btnPrev.disabled = disabled;
      btnNext.disabled = disabled;
    }

    btnPrev.addEventListener('click', () => step(-1));
    btnNext.addEventListener('click', () => step(1));
    track.addEventListener('transitionend', onTransitionEnd);

    root.setAttribute('tabindex', '0');
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft'){ e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight'){ e.preventDefault(); step(1); }
    });

    // ====== Drag / Swipe que respeta links ======
    const THRESHOLD_RATIO   = 0.25; // % del ancho del slide para decidir avanzar
    const VELOCITY_THRESH   = 0.5;  // px/ms para “flick”
    const ACTIVATE_DRAG_PX  = 10;   // píxeles horizontales para activar drag
    const VSCROLL_TOL_PX    = 6;    // tolerancia vertical antes de ceder al scroll

    function onPointerDown(ev){
      // Solo botón principal o toque
      if (ev.pointerType === 'mouse' && ev.button !== 0) return;

      isPointerDown = true;
      dragActive    = false;
      didSwipe      = false;
      preventClick  = false;

      startX = ev.clientX;
      startY = ev.clientY;
      deltaX = 0;
      deltaY = 0;
      startT = performance.now();

      // No capturamos puntero aún (para no interferir con click nativo)
      baseOffsetPx = offsetForIndex(currentIndex);
    }

    function onPointerMove(ev){
      if (!isPointerDown) return;

      const x = ev.clientX;
      const y = ev.clientY;

      deltaX = x - startX;
      deltaY = y - startY;

      // Si la intención es vertical, ceder al scroll nativo
      if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > VSCROLL_TOL_PX){
        isPointerDown = false;
        dragActive    = false;
        didSwipe      = false;
        preventClick  = false;
        enableTransition();
        applyTransform();
        root.classList.remove('x-dragging');
        root.style.userSelect = '';
        return;
      }

      // Activar drag al superar el umbral horizontal
      if (!dragActive && Math.abs(deltaX) >= ACTIVATE_DRAG_PX){
        dragActive = true;

        // Ahora sí, capturamos el puntero para seguir aunque salga del viewport
        if (viewport.setPointerCapture) {
          try { viewport.setPointerCapture(ev.pointerId); } catch(_) {}
        }

        disableTransition();
        root.classList.add('x-dragging');
        root.style.userSelect = 'none';
      }

      // Si drag activo, seguir el dedo
      if (dragActive){
        const provisional = baseOffsetPx - deltaX;
        applyTransformPx(provisional);
      }
    }

    function onPointerUp(ev){
      if (!isPointerDown){
        return;
      }

      // Si nunca activamos drag, dejamos que el click nativo suceda
      if (!dragActive){
        isPointerDown = false;
        dragActive    = false;
        didSwipe      = false;
        preventClick  = false;
        return;
      }

      // Drag estaba activo: decidir si hay swipe
      isPointerDown = false;

      if (viewport.releasePointerCapture) {
        try { viewport.releasePointerCapture(ev.pointerId); } catch(_) {}
      }

      const elapsed  = Math.max(1, performance.now() - startT); // ms
      const velocity = Math.abs(deltaX) / elapsed; // px/ms
      const stepSize = (slideW + gapPx);
      const threshold = stepSize * THRESHOLD_RATIO;

      let dir = 0;
      if (Math.abs(deltaX) >= threshold || velocity >= VELOCITY_THRESH){
        dir = deltaX > 0 ? -1 : 1; // arrastro a la derecha => slide anterior
      }

      enableTransition();

      if (dir !== 0){
        didSwipe = true;
        preventClick = true; // solo bloquea el click inmediatamente posterior

        if(!isAnimating){
          isAnimating = true;
          updateButtonsState(true);
          currentIndex += dir;
          applyTransform();

          // Fallback por si no llega transitionend
          const dur = getTransitionMs() || 350;
          setTimeout(() => {
            if (isAnimating) onTransitionEnd();
          }, dur + 60);
        }
      } else {
        didSwipe = false;
        preventClick = false;
        applyTransform();
      }

      root.classList.remove('x-dragging');
      root.style.userSelect = '';

      // limpiar flags de drag
      dragActive = false;
    }

    function onPointerCancel(){
      if (!isPointerDown) return;

      isPointerDown = false;
      dragActive    = false;
      didSwipe      = false;
      preventClick  = false;

      enableTransition();
      applyTransform();
      root.classList.remove('x-dragging');
      root.style.userSelect = '';
    }

    // Listeners
    viewport.addEventListener('pointerdown', onPointerDown, { passive: true });
    viewport.addEventListener('pointermove', onPointerMove, { passive: true });
    viewport.addEventListener('pointerup', onPointerUp, { passive: true });
    viewport.addEventListener('pointercancel', onPointerCancel, { passive: true });
    viewport.addEventListener('pointerleave', (e)=>{ if(isPointerDown) onPointerUp(e); }, { passive: true });

    // Ya NO bloqueamos todos los clicks del viewport:
    // Solo cancelamos el click inmediatamente posterior a un swipe real.
    viewport.addEventListener('click', (e) => {
      if (preventClick){
        e.preventDefault();
        e.stopPropagation();
        preventClick = false; // desbloquear siguientes
      }
    }, true);

    // ====== Resize / observadores ======
    let lastPerView = getItemsPerView();
    const handleResize = () => {
      const now = getItemsPerView();
      if (now !== lastPerView){
        lastPerView = now;
        build();
      } else {
        realignWithoutTransition();
      }
    };

    window.addEventListener('resize', debounce(handleResize, 100), { passive: true });

    if ('ResizeObserver' in window){
      const ro = new ResizeObserver(() => handleResize());
      ro.observe(viewport);
    }

    window.addEventListener('load', () => realignWithoutTransition());

    // Inicialización
    build();
  }

  // ====== util: debounce sencillo ======
  function debounce(fn, wait){
    let t = null;
    return function(){
      clearTimeout(t);
      const args = arguments;
      const ctx = this;
      t = setTimeout(() => fn.apply(ctx, args), wait);
    };
  }

})();

